import React, { 
  useState, 
  useEffect 
} from 'react'  
import { 
  useNavigate, 
  useParams
} from 'react-router-dom'
import { 
  useGame,
  useAvatar,
  useUser
} from 'data/hooks'

import edit from 'assets/icons/icon-edit.svg'

export const Avatar = props => {

  const { userId } = useUser()
  const gameId = useParams().gameId || playmotiv.game?.gameId
  const game = useGame(gameId)
  const { avatar } = useAvatar(gameId, userId)
  const navigate = useNavigate()
  const profilepath = props.profilepath || '/profile'

  return <div 
    className={`
      avatar
      ${ game.player?.groupId } 
    `}
  >
    <div className={`
      image
    `}>
      <img src={ avatar } />
    </div>
    <div 
      className="icon"
      onClick={ () => navigate(profilepath) }
    >
      <img src={ edit } />
    </div>
  </div>
}
